import { Message } from './types';

export const messages: Message = {
	createIssueModalHeader: 'Create issue',
	createIssueModalInput1Label: 'Project',
	createIssueModalInput2Label: 'Issue type',
	createIssueModalInput3Label: 'Summary',
	createIssueModalInput3Placeholder: 'Ex: Create a requirements doc',
	createIssueModalInput4Label: 'Issue description',
	createIssueModalInput4Placeholder:
		'Add notes: \nWrite details here like receive final prototypes from design. \n \nAdd tasks: \nWrite necessary tasks to complete your project here.',
	createIssueModalInput5Label: 'Priority',
	createIssueModalInput6Label: 'Epic link',
	createIssueModalInput7Label: 'Assignee',
	createIssueModalInput8Label: 'Due date',
	createIssueModalProjectOption1: 'Team Rocket',
	createIssueModalProjectAssetLabel1: 'project team rocket',
	createIssueModalIssueTypeOption1: 'Task',
	createIssueModalIssueTypeAssetLabel1: 'Issue type: Task',
	createIssueModalIssueTypeOption2: 'Story',
	createIssueModalIssueTypeAssetLabel2: 'Issue type: Story',
	createIssueModalIssueTypeOption3: 'Bug',
	createIssueModalIssueTypeAssetLabel3: 'Issue type: Bug',
	createIssueModalAssigneeOption1: 'Alvin',
	createIssueModalAssigneeAssetLabel1: 'Assignee: Alvin',
	createIssueModalAssigneeOption2: 'Jane',
	createIssueModalAssigneeAssetLabel2: 'Assignee: Jane',
	createIssueModalAssigneeOption3: 'Blake',
	createIssueModalAssigneeAssetLabel3: 'Assignee: Blake',
	createIssueModalPriorityOption1: 'High',
	createIssueModalPriorityAssetLabel1: 'Priority: High',
	createIssueModalPriorityOption2: 'Critical',
	createIssueModalPriorityAssetLabel2: 'Priority: Critical',
	createIssueModalPriorityOption3: 'Blocker',
	createIssueModalPriorityAssetLabel3: 'Priority: Blocker',
	createIssueModalPriorityOption4: 'Minor',
	createIssueModalPriorityAssetLabel4: 'Priority: Minor',
	createIssueModalEpicLinkOption1: 'Features',
	createIssueModalEpicLinkOption1Description: 'APP-153',
	createIssueModalEpicLinkAssetLabel1: 'Epic link: Features',
	createIssueModalEpicLinkOption2: 'Analytics',
	createIssueModalEpicLinkOption2Description: 'APP-154',
	createIssueModalEpicLinkAssetLabel2: 'Epic link: Features',
	createIssueModalEpicLinkOption3: 'Payments',
	createIssueModalEpicLinkOption3Description: 'APP-155',
	createIssueModalEpicLinkAssetLabel3: 'Epic link: Payments',
	createIssueModalSubmitBtn: 'Create',
	createIssueModalCloseBtn: 'Close modal',
	toDo: 'To Do',
	inProgress: 'In Progress',
	done: 'Done',
	create: 'Create',
	restartDemo: 'Restart demo',
	avatarGroupAriaLabel: 'Collection of user avatars showing team members',
	todoStaticLabel: 'Design AI shopping suggestions for homepage',
	inProgStaticLabel1: 'Create AI-generated shopping suggestions for homepage',
	inProgStaticLabel2: 'Add advanced analytics tracking events',
	doneStaticLabel1: 'Improve payment checkout time on mobile',
	doneStaticLabel2: 'Define requirements to use new AI integrations',
	spotlightInitialCreateButtonHeading: "Let's set up your board",
	spotlightInitialCreateButtonDescription:
		'Kanban boards are great for project management. Select create to start tracking work that your team would like to do.',
	spotlightSelectIssueHeading: 'Create an issue',
	spotlightSelectIssueDescription:
		'Issues are used to track work in Jira. Tasks, stories, and bugs are different types of issues. Select what type of issue you’d like to create.',
	spotlightMoveIssueHeading: 'Move your task to the board',
	spotlightMoveIssueDescription: `Now that you’ve added all the info to your task. Select create to see your work on the “To-do” list.`,
	spotlightSummaryHeading: 'Tell us about your work',
	spotlightSummaryDescription:
		'Summarize your to-do in a few words. It can be anything, like complete mobile app designs or developing a new feature.',
	spotlightAddDescriptionHeading: 'Provide useful details',
	spotlightAddDescriptionDescription:
		'Add any important information about the work that’s needed to move it forward.',
	spotlightSelectPriorityHeading: 'Prioritize your task',
	spotlightSelectPriorityDescription:
		'Choose the importance of a task to change how it appears on the board. Select a level of priority to identify this task at a glance.',
	spotlightSelectEpicLinkHeading: 'Connect work to larger projects',
	spotlightSelectEpicLinkDescription:
		'You can connect this issue to longer term projects. This will help your team plan accurately.',
	staticSpotlightHeading: 'Expand your screen size to use this demo',
	successModalHeading: 'Congrats, you’ve made your first issue!',
	successModalDescription:
		'You’ve taken the first step towards streamlined collaboration and task tracking. Get started for free using the project management template in Jira.',
	successModalCtaButton: 'Get it free',
};
